import React from 'react';

import {MinimalHeader} from '@udemy/react-structure-components';

import {DemoFormHeaderLogin} from '../demo-form-header-login/demo-form-header-login.react-component';
import {DemoFormHeaderUFBLogo} from './demo-form-header-ufb-logo.react-component';
import {DemoFormHeaderProps} from './demo-form-header.react-component';

export const DesktopDemoFormHeader = (props: DemoFormHeaderProps) => {
    const renderLogo = () => {
        return (
            <DemoFormHeaderUFBLogo
                imgHeight={34}
                imgWidth={200}
                href={props.logoButtonHref}
                onClick={props.onLogoButtonClick}
            />
        );
    };

    return (
        <div data-testid="desktop-header">
            <MinimalHeader renderLogo={renderLogo}>
                <DemoFormHeaderLogin {...props.loginProps} />
            </MinimalHeader>
        </div>
    );
};
